/** Erreurs de validation sur les lignes banques d'heures / absences (préfixe `bankHoursList.`). */
export function bankHoursTabHasValidationErrors(errors: Record<string, string>): boolean {
  return Object.keys(errors).some((k) => k.startsWith("bankHoursList."));
}
